/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { I18nService } from '@dm/core';
import { type MappingView } from 'app/common/types/mo';
import { DataTypeId } from 'app/feature/share/global-search/global-infigo/const';
import { type Observable } from 'rxjs';

import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';
import { MappingTableComponent } from '../../resource-table/mapping-table/mapping-table.component';

@Component({
    selector: 'app-lun-resource',
    templateUrl: './lun-resource.component.html',
    styleUrls: ['../../resource.scss'],
})
export class LunResourceComponent extends RefreshComponent {
    @Input() data;
    @ViewChild('mappingTable', { static: true }) mappingTable: MappingTableComponent;
    defaultTabItem: string = this.i18n.get('home.search_term_mappedHosts_lab');
    activeTabItem: string = this.defaultTabItem;
    mappingList: MappingView[] = [];
    loading = true;
    propName = 'data';

    constructor(private i18n: I18nService, public infigoService: InfigoService, public changeDetectorRef: ChangeDetectorRef) {
        super();
    }

    // 获取LUN的mapping关系
    requestInfo(): Observable<any> {
        return this.infigoService.getAssociateMappings(DataTypeId[this.data.type], this.data.actionParams);
    }

    handleRequest(value: any): void {
        this.mappingList = value.data;
        this.loading = false;
        this.clearTimer();
        this.updateLoading = false;
        this.changeDetectorRef.detectChanges();
    }
}
